import {useState,useEffect} from "react";
import { Link } from "react-router-dom";
import "../../style/scss/selectionPanel.scss"; // Updated to use SCSS instead of CSS
import { MdCheckBoxOutlineBlank, MdOutlineCheckBox } from "react-icons/md";

export default function SkillSelectionListItem(props) {
   const onClick = (e) => {
      if (props.onChange) props.onChange(props.skill.ID, e);
      if (props.onClick) props.onClick(props.skill.ID, e);
   };
   return (
      <li key={props.skill.ID}>
         <span className="centered skillLink " onClick={props.onClick}>
            <div
               className={"Job selectionPanel checkRow" + (props.selected ? " selected" : "")}
               id={props.skill.ID}
               onClick={onClick}
            >
               <span className="icon">
                  <MdCheckBoxOutlineBlank
                     size={1}
                     color="#0075FF"
                     className={props.selected ? "hidden" : ""}
                  />
                  <MdOutlineCheckBox size={1} color="#0075FF" className={props.selected ? "" : "hidden"} />
               </span>
               <span className="title">{props.skill.ShortName || props.skill.Name}</span>
               <span className="byline"></span>
               <span className="rightText">{props.skill.IndustryName}</span>
            </div>
         </span>
      </li>
   );
}


